import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

const AttachFile = ({ sm, handleDownloadAttach }) => {
  if (!sm?.isAttachFile) return null;

  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      onClick={(event) => event.stopPropagation()}
      sx={{ p: 1.5, borderRadius: 2, bgcolor: "action.selected", minWidth: 220 }}
    >
      <InsertDriveFileOutlinedIcon />
      <Box flexGrow={1} minWidth={0}>
        <Typography variant="body2" fontWeight={500} noWrap title={sm.fileName}>
          {sm.fileName || "Arquivo"}
        </Typography>
        {sm.fileType && (
          <Typography variant="caption" sx={{ opacity: 0.8 }} noWrap component="div">
            {sm.fileType}
          </Typography>
        )}
        {sm.urlAttachFile && (
          <Link
            href={sm.urlAttachFile}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            variant="caption"
          >
            Abrir anexo
          </Link>
        )}
      </Box>
      <Tooltip title="Baixar">
        <IconButton size="small" color="inherit" onClick={() => handleDownloadAttach(sm)}>
          <DownloadIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default AttachFile;
